"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fixExternalImageSrc_1 = __importDefault(require("./fixExternalImageSrc"));
var UPLOADCARE_CDN_URL = 'https://cdn.uc.assets.prezly.com';
var UPLOADCARE_MEDIA_PROXY_URL = 'https://proxy.uc.assets.prezly.com/';
var UPLOADCARE_GIF2VIDEO_PATH = 'gif2video';
var handleEffects = function (options) {
    var effects = options.effects, restOptions = __rest(options, ["effects"]);
    return effects.map(function (effect) {
        if (typeof effect === 'function') {
            return effect(restOptions);
        }
        return effect;
    });
};
var prepareUploadcareMediaProxyUrl = function (options) {
    var imageDetails = options.imageDetails, src = options.src, effects = options.effects, isGif2Video = options.isGif2Video;
    var mergedEffects = __spreadArray(__spreadArray([], __read(((imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.effects) || []))), __read(effects));
    return [
        UPLOADCARE_MEDIA_PROXY_URL,
        isGif2Video && UPLOADCARE_GIF2VIDEO_PATH,
        mergedEffects.length === 0
            ? mergedEffects
            : __spreadArray([''], __read(handleEffects(__assign(__assign({}, options), { effects: mergedEffects })))).join('-'),
        fixExternalImageSrc_1.default(src),
    ]
        .filter(Boolean)
        .join('/');
};
var prepareUploadcareUrl = function (options) {
    var imageDetails = options.imageDetails, src = options.src, filename = options.filename, effects = options.effects, isGif2Video = options.isGif2Video;
    var mergedEffects = __spreadArray(__spreadArray([], __read(((imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.effects) || []))), __read(effects));
    // if external image, use media-proxy
    if (src) {
        return prepareUploadcareMediaProxyUrl(options);
    }
    return [
        UPLOADCARE_CDN_URL,
        imageDetails.uuid,
        isGif2Video && UPLOADCARE_GIF2VIDEO_PATH,
        mergedEffects.length === 0
            ? mergedEffects
            : __spreadArray([''], __read(handleEffects(__assign(__assign({}, options), { effects: mergedEffects })))).join('-'),
        filename,
    ]
        .filter(Boolean)
        .join('/');
};
exports.default = prepareUploadcareUrl;
//# sourceMappingURL=prepareUploadcareUrl.js.map